module.exports = __webpack_public_path__ + "img/about.f71035c4.jpg";